//      
import React, { Component } from 'react';

import { mergeClassNames } from 'utils/functions';

              
                  
                 
                     
                      
                       
                       
                           
                             
                       
 

export class RadioSelect extends Component        {

    render() {
        let {name, choices, errors, errorText, helpText, defaultChecked, onChange, className, readonly, ...domProps} = this.props;
        const errorClass = errorText ? 'is-invalid' : '';
        className = mergeClassNames('form-check', className, errorClass);

        return (
            <div className={className} {...domProps}>
                { choices.map((choice, index) => (
                    <React.Fragment key={index}>
                        <input
                            className='form-check-input'
                            id={`id_${choice.value}`}
                            name={name}
                            type='radio'
                            value={choice.value}
                            defaultChecked={defaultChecked === choice.value ? true : false}
                            onChange={onChange}
                            disabled={readonly}
                            style={{ 'position': 'relative' }}
                        />
                        <label
                            className='form-check-label'
                            htmlFor={`id_${choice.value}`}
                            style={{marginRight: '2rem', marginLeft: '0.5rem'}}
                        >
                            {choice.label}
                        </label>
                    </React.Fragment>
                ))}
                {errorText && <small className="form-text text-danger">{errorText}</small>}
                {errors && errors.map((error, i) => <small key={i} className="form-text text-danger">{error}<br /></small>)}
                {helpText && <small className="form-text text-muted">{helpText}</small>}
            </div>
        );
    }
}
